import {connect} from 'react-redux';
import dashboardComponent from '../../Components/Backend/dashboard';
import { getDashboardWidgetData } from '../../redux/actions/DashboardAction';
import {withRouter} from 'react-router';

const dashboardContainer = connect(
    (state) => { //map state to props
        return {
            dashboard: state.dashbordReducer
        };
    },

    (dispatch) => {
        return {
            getDashboardWidgetData: () => {
                dispatch(getDashboardWidgetData());
            }
        };

    }
)(dashboardComponent);

export default withRouter(dashboardContainer);